import React, { useState } from "react";

export default function AddFormNumber() {
  const [form, setForm] = useState({
    customerName: "",
    username: "",
    email: "",
    password: "",
    brandName: "",
  });
  const [brandImage, setBrandImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  function handleImage(e) {
    const file = e.target.files[0];
    if (!file) return;
    setBrandImage(file);
    const reader = new FileReader();
    reader.onload = () => setPreviewUrl(reader.result);
    reader.readAsDataURL(file);
  }

  function handleSubmit(e) {
    e.preventDefault();
    alert("تم إرسال الفورم (محاكاة) 🚀");
  }

  return (
    <div className="form-container">
      <form className="form-box" onSubmit={handleSubmit}>
        <h2>  اضافة رقم جديد</h2>

        <label>
          اسم الرقم
          <input
            name="customerName"
            type="text"
            value={form.customerName}
            onChange={handleChange}
            placeholder="مثال: محمد علي"
          />
        </label>

        <label>
          قيمة الرقم
          <input
            name="customerName"
            type="text"
            value={form.customerName}
            onChange={handleChange}
            placeholder="مثال: محمد علي"
          />
        </label>

        <label>
          اسم البراند
          <input
            name="brandName"
            type="text"
            value={form.brandName}
            onChange={handleChange}
            placeholder="مثال: Nile Cosmetics"
          />
        </label>

          <label>
          اسم المنصة
          <input
            name="brandName"
            type="text"
            value={form.brandName}
            onChange={handleChange}
            placeholder="مثال: Nile Cosmetics"
          />
        </label>

        {previewUrl && (
          <div className="image-preview">
            <img src={previewUrl} alt="preview" />
          </div>
        )}

        <button type="submit">اضافة الرقم </button>
      </form>
    </div>
  );
}
